import { ArrowDropDown, LocalGroceryStoreOutlined, Logout, MenuOutlined, Person, PersonOutlineOutlined, Settings } from '@mui/icons-material'
import { Avatar, Badge, Box, Divider, IconButton, ListItemIcon, Menu, MenuItem, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../Redux/store'
import { setIsNeedtoShowConnectwithRazor, setOpenSideMenue, setToken, setUserDetails } from '../Redux/Reducers/globalSlice'
import { useNavigate } from 'react-router-dom'
import logo from '../assets/Images/Logo.png'


function Header() {
  const { userDetails, cartlist } = useSelector((state: RootState) => state.global)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const logout = () => {
    dispatch(setUserDetails(null))
    dispatch(setToken(""))
    navigate('/')
  }
  return (
    <Box className='border-bottom-main px-3 py-2' sx={{ height: '60px', bgcolor: "rgb(250,250,253)" }}>
      <Box className='d-flex algin-items-center justify-content-between'>
        <Box
          sx={{
            // height: 65,
            display: { xs: 'flex', md: "none" },
            alignItems: "center",
            // px: 2,
            justifyContent: "space-between",
          }}
        >
          <IconButton onClick={() => dispatch(setOpenSideMenue(true))}>
            <MenuOutlined className='text-main' sx={{ fontSize: '28px' }} />
          </IconButton>
        </Box>
        <Box className='d-none d-md-flex align-items-center gap-3'>
          <Box className='border-10 p-1 bg-light-main'>
            <PersonOutlineOutlined className='text-white' sx={{ fontSize: '32px' }} />
          </Box>
          <Box>
            <Typography variant='h6' className='fw-bold' sx={{ lineHeight: 'normal' }}>Welcome Back, {userDetails?.firstName} {userDetails?.lastName}</Typography>
            <Typography sx={{ fontSize: '12px' }}>Here's what's happening with your platform today</Typography>
          </Box>
        </Box>
        <Box className="d-flex d-md-none align-items-center gap-2">
          <Box component={'img'} className="p-1 border-10" src={logo} height={'50px'} alt="logo" />
          <Box>
            <Typography
              variant="body1"
              className='fw-bold mb-0 pb-0 logo-text' sx={{ lineHeight: 'normal' }}>
              <span className="text-dark">Wholesale</span> <span className="text-main">Pro</span>
            </Typography>
          </Box>
        </Box>
        <Box className='d-flex align-items-center gap-4'>
          {userDetails?.role === 'subclient' && (
            <Box>
              <IconButton onClick={() => { navigate(`/${userDetails?.role}/cart/cartlist`) }}>
                <Badge badgeContent={cartlist?.items?.length} className='text-white' sx={{ '& .MuiBadge-badge': { background: 'var(--primary-dark-color)' } }}>
                  <LocalGroceryStoreOutlined className='m-0 p-0 text-dark-main' sx={{ fontSize: '32px' }} />
                </Badge>
              </IconButton>
            </Box>
          )}
          <Box className='d-flex align-items-center gap-2 pointer' onClick={(e) => { handleMenuOpen(e) }}>
            <Avatar sx={{ background: 'var(--primary-color)', height: "32px", width: '32px', fontSize: "14px" }}>{userDetails?.firstName[0]}{userDetails?.lastName[0]}</Avatar>
            <Box>
              <Typography variant='body1' className='fw-bold d-none d-md-block' sx={{ lineHeight: 'normal' }}>{userDetails?.firstName} {userDetails?.lastName}</Typography>
              <Typography variant='body2' className='d-none d-md-block'>{userDetails?.role}</Typography>
            </Box>
            <ArrowDropDown className='d-none d-md-block' />
          </Box>
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          slotProps={{
            paper: {
              elevation: 4,
              sx: {
                mt: 1,
                minWidth: 220,
                borderRadius: 3,
              },
            },
          }}

        >
          {/* <MenuItem onClick={handleMenuClose}>
              <ListItemIcon>
                <Person fontSize="small" />
              </ListItemIcon>
              My Profile
            </MenuItem>

            <MenuItem onClick={handleMenuClose}>
              <ListItemIcon>
                <Settings fontSize="small" />
              </ListItemIcon>
              Settings
            </MenuItem>

            <Divider /> */}

          <MenuItem
            onClick={() => {
              // handleMenuClose();
              logout();
            }}
            sx={{ color: "error.main" }}
          >
            <ListItemIcon>
              <Logout color="error" fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  )
}

export default Header
